import { render, staticRenderFns } from "./CardPreHeader.vue?vue&type=template&id=60ca5d9a&"
import script from "./CardPreHeader.vue?vue&type=script&lang=js&"
export * from "./CardPreHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports